<template>
  <footer>



    <section id="block-1" class="newsletter newsletter-hubspot mdc-theme--dark" style="background-color: #fff; padding-bottom: 45px; padding-top: 45px;">
      <div class="container">
        <div class="corner corner--blue">
          <div class="corner__body">
            <div class="newsletter__body">

              <div class="heading heading--1">Bleiben Sie up-to-date mit unserem Newsletter!</div>


              <div class="hubspot-form-root hbspt-form" data-hs-forms-root="true"><form id="hsForm_afce64ef-653d-4b7d-bcdd-7386396dab69" method="POST" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="" action="https://forms-eu1.hsforms.com/submissions/v3/public/submit/formsnext/multipart/27068655/afce64ef-653d-4b7d-bcdd-7386396dab69" class="hs-form-private hsForm_afce64ef-653d-4b7d-bcdd-7386396dab69 hs-form-afce64ef-653d-4b7d-bcdd-7386396dab69 hs-form-afce64ef-653d-4b7d-bcdd-7386396dab69_27232444-eec0-4021-8d24-c5cf97a2d516 hs-form stacked" target="target_iframe_afce64ef-653d-4b7d-bcdd-7386396dab69" data-instance-id="27232444-eec0-4021-8d24-c5cf97a2d516" data-form-id="afce64ef-653d-4b7d-bcdd-7386396dab69" data-portal-id="27068655" data-test-id="hsForm_afce64ef-653d-4b7d-bcdd-7386396dab69"><div><div class="hs-richtext hs-main-font-element"><h1>Jetzt Newsletter abonnieren!</h1></div></div><div class="hs_email hs-email hs-fieldtype-text field hs-form-field"><label id="label-email-afce64ef-653d-4b7d-bcdd-7386396dab69" class="" for="email-afce64ef-653d-4b7d-bcdd-7386396dab69"><span>E-Mail</span><span class="hs-form-required">*</span></label><div class="input"><input id="email-afce64ef-653d-4b7d-bcdd-7386396dab69" name="email" required="" placeholder="" type="email" class="hs-input" inputmode="email" autocomplete="email" value=""></div></div><div class="hs_submit hs-submit"><div class="hs-field-desc" style="display: none;"></div><div class="actions"><input type="submit" class="hs-button primary large" value="Jetzt abonnieren"></div></div><input name="hs_context" type="hidden" value="{&quot;embedAtTimestamp&quot;:&quot;1771258002376&quot;,&quot;formDefinitionUpdatedAt&quot;:&quot;1692881487194&quot;,&quot;lang&quot;:&quot;de&quot;,&quot;embedType&quot;:&quot;REGULAR&quot;,&quot;disableCookieSubmission&quot;:&quot;true&quot;,&quot;renderRawHtml&quot;:&quot;true&quot;,&quot;userAgent&quot;:&quot;Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36&quot;,&quot;pageTitle&quot;:&quot;Theben AG - KNX, DALI, Zeitschaltuhren, Bewegungsmelder, Smart Home | Theben AG&quot;,&quot;pageUrl&quot;:&quot;https://www.theben.de/&quot;,&quot;isHubSpotCmsGeneratedPage&quot;:false,&quot;hutk&quot;:&quot;4fa11b1cf30250b0980daa995e760ebe&quot;,&quot;__hstc&quot;:&quot;12974248.4fa11b1cf30250b0980daa995e760ebe.1770107499114.1770884940750.1770981155626.12&quot;,&quot;formTarget&quot;:&quot;.hubspot-form-root&quot;,&quot;rumScriptExecuteTime&quot;:403,&quot;rumTotalRequestTime&quot;:650.6000000014901,&quot;rumTotalRenderTime&quot;:675,&quot;rumServiceResponseTime&quot;:247.60000000149012,&quot;rumFormRenderTime&quot;:24.399999998509884,&quot;connectionType&quot;:&quot;4g&quot;,&quot;firstContentfulPaint&quot;:0,&quot;largestContentfulPaint&quot;:0,&quot;locale&quot;:&quot;de&quot;,&quot;timestamp&quot;:1771258002516,&quot;originalEmbedContext&quot;:{&quot;portalId&quot;:&quot;27068655&quot;,&quot;formId&quot;:&quot;afce64ef-653d-4b7d-bcdd-7386396dab69&quot;,&quot;region&quot;:&quot;eu1&quot;,&quot;target&quot;:&quot;.hubspot-form-root&quot;,&quot;isBuilder&quot;:false,&quot;isTestPage&quot;:false,&quot;isPreview&quot;:false,&quot;isMobileResponsive&quot;:true},&quot;correlationId&quot;:&quot;27232444-eec0-4021-8d24-c5cf97a2d516&quot;,&quot;renderedFieldsIds&quot;:[&quot;email&quot;],&quot;captchaStatus&quot;:&quot;NOT_APPLICABLE&quot;,&quot;emailResubscribeStatus&quot;:&quot;NOT_APPLICABLE&quot;,&quot;isInsideCrossOriginFrame&quot;:false,&quot;source&quot;:&quot;forms-embed-1.10554&quot;,&quot;sourceName&quot;:&quot;forms-embed&quot;,&quot;sourceVersion&quot;:&quot;1.10554&quot;,&quot;sourceVersionMajor&quot;:&quot;1&quot;,&quot;sourceVersionMinor&quot;:&quot;10554&quot;,&quot;allPageIds&quot;:{},&quot;_debug_embedLogLines&quot;:[{&quot;clientTimestamp&quot;:1771258002487,&quot;level&quot;:&quot;INFO&quot;,&quot;message&quot;:&quot;Retrieved pageContext values which may be overriden by the embed context: {\&quot;pageTitle\&quot;:\&quot;Theben AG - KNX, DALI, Zeitschaltuhren, Bewegungsmelder, Smart Home | Theben AG\&quot;,\&quot;pageUrl\&quot;:\&quot;https://www.theben.de/\&quot;,\&quot;userAgent\&quot;:\&quot;Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36\&quot;,\&quot;isHubSpotCmsGeneratedPage\&quot;:false}&quot;},{&quot;clientTimestamp&quot;:1771258002490,&quot;level&quot;:&quot;INFO&quot;,&quot;message&quot;:&quot;Retrieved countryCode property from normalized embed definition response: \&quot;DE\&quot;&quot;}],&quot;recaptchaVersion&quot;:&quot;v2&quot;}"><iframe name="target_iframe_afce64ef-653d-4b7d-bcdd-7386396dab69" style="display: none;"></iframe></form></div>
            </div>
          </div>
        </div>
      </div>
    </section>






    <div class="service-bar">
      <div class="service-bar__container container">

        <div class="service-bar__item">
          <div class="service-bar__inner">

            <svg class="icon icon-company" viewBox="0 0 32 32"><use xlink:href="#company"></use></svg>


            <div class="heading heading--4">Theben AG</div>


            <p>Hohenbergstraße 32<br> 72401 Haigerloch<br><br> Zentrale: <a href="tel:+49%20(0)74 74/ 692-0">+49 (0)74 74/692-0</a><br>Vertriebsservice: <a class="phone-link" title="Vertriebssvervice" href="tel:+49%20(0)74 74/ 692-533">+49 (0)74 74/ 692-533</a><br>E-Mail: <a href="mailto:info@theben.de?subject=Kontakt">info@theben.de</a></p>

          </div>
        </div>

        <div class="service-bar__item">
          <div class="service-bar__inner">

            <svg class="icon icon-headphone" viewBox="0 0 32 32"><use xlink:href="#headphone"></use></svg>


            <div class="heading heading--4">Support</div>


            <p>Montag bis Donnerstag: 07.30 bis 12.30 Uhr und 13.00 bis 17.30 Uhr</p><p>Freitag: 07.30 bis 12.30 Uhr und 13.00 bis 15.00 Uhr<br><br> Telefon: <a class="phone-link" href="tel:+49%20(0) 7474/692-369">+49 (0) 7474/692-369</a><br>E-Mail: <a href="mailto:techsupport@theben.de">techsupport@theben.de</a></p>

          </div>
        </div>

        <div class="service-bar__item">
          <div class="service-bar__inner">

            <svg class="icon icon-service" viewBox="0 0 32 32"><use xlink:href="#service"></use></svg>


            <div class="heading heading--4">Service</div>


            <p><a href="https://www.theben.de/de/downloads/" target="_blank">Downloads</a><br>
              <a title="Katalogbestellung" href="https://www.theben.de/service/katalogbestellung/" target="_blank">Katalogbestellung</a><br>
              <a title=" Kataloge und Prospekte" href="http://www.theben.de/service/kataloge-und-prospekte/" target="_blank">Kataloge und Prospekte</a><br>
              <a title="Seminare und Webinare" href="http://www.theben.de/service/fachseminare/" target="_blank">Seminare und Webinare</a><br>
              <a title="Fachpresse" href="http://www.theben.de/unternehmen/aktuelles/fachpresse/" target="_blank">Fachpresse</a></p>

          </div>
        </div>

        <div class="service-bar__item">
          <div class="service-bar__inner">

            <svg class="icon icon-world" viewBox="0 0 32 32"><use xlink:href="#world"></use></svg>


            <div class="heading heading--4">Karriere</div>


            <p>Sie wollen Teil unseres Teams werden?&nbsp;</p><ul>
            <li><a href="https://www.theben.de/theben-karriere/karriere/" target="_blank">Karriere bei Theben</a></li>
            <li><a href="https://karriere.theben.de/" target="_blank">Stellenangebote</a></li>
            <li><a href="https://www.theben.de/theben-karriere/karriere/ausbildung/" target="_blank">Ausbildung</a></li>
            <li><a href="https://www.theben.de/theben-karriere/karriere/studierende/" target="_blank">Studium</a></li>
          </ul>

          </div>
        </div>

      </div>
    </div>

    <div class="social-bar">
      <div class="social-bar__text">
        Besuchen Sie uns auf:
      </div>
      <div>

        <a href="https://www.youtube.com/user/TheThebenAG" title="Youtube">
          <svg class="icon icon-youtube" viewBox="0 0 32 32">
            <use xlink:href="#youtube"></use>
          </svg>
        </a>

        <a href="https://www.instagram.com/theben_ag/" title="Instagram">
          <svg class="icon icon-instagram" viewBox="0 0 32 32">
            <use xlink:href="#instagram"></use>
          </svg>
        </a>

        <a href="https://twitter.com/Theben_AG" title="Twitter">
          <svg class="icon icon-twitter" viewBox="0 0 32 32">
            <use xlink:href="#twitter"></use>
          </svg>
        </a>

        <a href="https://www.facebook.com/ThebenAG/" title="Facebook">
          <svg class="icon icon-facebook" viewBox="0 0 32 32">
            <use xlink:href="#facebook"></use>
          </svg>
        </a>

        <a href="https://de.linkedin.com/company/theben-ag" title="linkedin">
          <svg class="icon icon-linkedin" viewBox="0 0 32 32">
            <use xlink:href="#linkedin"></use>
          </svg>
        </a>

        <a href="https://www.kununu.com/de/theben" title="kununu">
          <svg class="icon icon-kununu" viewBox="0 0 32 32">
            <use xlink:href="#kununu"></use>
          </svg>
        </a>

        <a href="https://www.xing.com/companies/thebenag" title="xing">
          <svg class="icon icon-xing" viewBox="0 0 32 32">
            <use xlink:href="#xing"></use>
          </svg>
        </a>

      </div>

    </div>

    <div class="container mx-auto">
      <b-navbar toggleable="md" class="mx-auto bordertop">

        <b-navbar-nav class="mx-auto">
          <b-nav-item @click="openLegals($t('views.partials.footer.legal'),'legal')">
            {{ $t('views.partials.footer.legal') }}
          </b-nav-item>
          <b-nav-item @click="openLegals($t('views.partials.footer.privacy'),'privacy')">
            {{ $t('views.partials.footer.privacy') }}
          </b-nav-item>
          <b-nav-item :href="termsLink" target="_blank">{{
              $t('views.partials.footer.terms')
            }}
          </b-nav-item>
<!--          <b-nav-item @click="openLegals($t('views.partials.footer.cancellation'),'cancellation')">-->
<!--            {{ $t('views.partials.footer.cancellation') }}-->
<!--          </b-nav-item>-->
          <b-nav-text disabled>
            {{ $t('views.partials.footer.language') }}
            <b-link @click="changeLocale('en')">EN</b-link>
            |
            <b-link @click="changeLocale('de')">DE</b-link>
            |
            <b-link @click="changeLocale('fr')">FR</b-link>
            |
            <b-link @click="changeLocale('it')">IT</b-link>
            |
            <b-link @click="changeLocale('es')">ES</b-link>
            |
            <b-link @click="changeLocale('nl')">NL</b-link>

          </b-nav-text>
        </b-navbar-nav>
      </b-navbar>
      <div class="mx-auto text-center small-text-info">
        <small class="text-muted">© 2026 myTheben Portal <a href="https://www.theben.de/" target="_blank">
          theben.de </a></small>
      </div>

      <p class="version"> ¤ {{ version }}</p>
      <LegalsModal/>
    </div>
  </footer>

</template>

<script>
import cfg from "@/services/config";
import EventBus from "@/views/partials/EventBus";
import LegalsModal from "@/views/modals/Legals";

export default {
  components: {
    LegalsModal: LegalsModal
  },
  methods: {
    changeLocale(_locale) {
      localStorage.setItem('lang', _locale);
      this.$i18n._vm.locale = _locale;
    },
    openLegals(title, tmpl) {
      EventBus.$emit('openLegalModal', title, tmpl + "-" + this.$i18n._vm.locale + ".html");
    }

  },
  computed: {
    version: () => cfg.portalVersion,
      termsLink() {
          return "./html/terms-" + this.$i18n._vm.locale + ".html";
      },
  }
};
</script>

<style lang="scss" scoped>
footer {
  position: relative;
  font-weight: 100;
  background-color: #00487b;
  text-align: left;
  color: white;

  .version {
    position: absolute;
    right: 16px;
    color: rgba(0, 0, 0, 0.55);
    bottom: -10px;
    font-size: 0.6em;
  }

  .small-text-info {
    padding-bottom: 15px;
  }

  //background: linear-gradient(90deg, rgb(12, 59, 107) 0%, rgb(29, 86, 148) 80%);
  //padding: 45px 30px

}

footer svg {
  overflow: hidden;
  vertical-align: middle !important;
  margin-bottom: 7px;
  color: greenyellow;
}

footer a, footer small, footer li {
  color: white!important;
  //color: #00487b !important;
  //text-decoration: underline;
  cursor: pointer;
}

footer a {
  text-decoration: underline !important;
}

footer .heading {
  margin: 0 0 20px 0 !important;
}

footer p {
  display: block !important;;
  margin-block-start: 1em !important;;
  margin-block-end: 1em !important;;
  margin-inline-start: 0px !important;;
  margin-inline-end: 0px !important;;
  font-size: 16px !important;
}

.bordertop{
  border-top: 1px solid #8dc474;
}

.service-bar {
  color: white;
  background-color: transparent;
  padding-top: 50px;
  padding-bottom: 20px;
}


.service-bar__container {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}

.service-bar .icon {
  color: #8dc474;
  stroke: #8dc474;
  fill: #8dc474;
}

.newsletter__body {
  padding: 15px;
}

.hbspt-form h1 {
  display: none;
}

.hbspt-form form .hs_email.hs-email.hs-fieldtype-text.field.hs-form-field {
  max-width: 500px;
}

.hs-form-afce64ef-653d-4b7d-bcdd-7386396dab69_27232444-eec0-4021-8d24-c5cf97a2d516 .hs-field-desc {
  width: 100%;
}

.hbspt-form .input {
  margin-bottom: 40px;
}

.hbspt-form .hs-submit .hs-button {
  outline: none;
  width: 250px;
  text-align: center;
  display: inline-block;
  color: #00487b;
  border: 1px solid #fff;
  background-color: #8dc474 !important;
  border-radius: 4px;
  text-decoration: none;
  font-family: "NettoWebPro", -apple-system, system-ui, sans-serif, swap;
  font-size: 1rem;
  line-height: 2;
  padding: 3px 20px;
  cursor: pointer;
  transition: -webkit-transform 0.6s
  ease-out;
  transition: transform 0.6s
  ease-out, -webkit-transform 0.6s
  ease-out;
}

.hbspt-form .hs-form-field .hs-input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]) {
  outline: none;
  border: none;
  width: 100% !important;
  height: 40px;
  border-left: 1px solid #c4c7c8;
  border-bottom: 1px solid #c4c7c8;
  border-radius: 0 0 0 4px;
  font-family: "NettoWebPro", -apple-system, system-ui, sans-serif, swap;
  font-size: inherit;
  line-height: 22px;
  background-color: transparent;
  padding: 10px 10px 8px;
  color: #fff;
}

.hbspt-form .hs-submit .hs-button:hover {
  color: #fff;
  background-color: #0f90d0 !important;
  border-color: #fff !important;
}

@media (min-width: 768px) {
  .service-bar {
    padding-top: 60px;
    padding-bottom: 0;
  }
}

@media(max-width: 1400px) {
  .social-bar {
    max-width: 1120px !important;
  }
}


@media(max-width: 1200px) {
  .social-bar {
    max-width: 920px !important;
  }
}

@media (max-width: 992px) {
  .service-bar {
    padding-top: 70px;
  }
  .social-bar {
    max-width: 680px !important;
  }
}

@media (max-width: 768px) {
  .social-bar {
    flex-flow: column !important;
  }

  .navbar {
    text-align: center;
  }
}

footer .mx-auto {
  background-color: transparent !important;
  //border-top: 3px solid #c4c7c8;

}

.service-bar__item {
  display: -webkit-flex;
  display: flex;
  width: 100%;
  padding: 0 30px 30px 0;
}

@media (min-width: 768px) {
  .service-bar__item {
    width: 50%;
    padding-bottom: 60px;
  }
}

@media (min-width: 992px) {
  .service-bar__item {
    width: 25%;
    padding-bottom: 70px;
  }
}

.service-bar__inner {
  border-left: 3px solid rgba(0, 72, 123, 0.5);
  padding-left: 30px;
  text-align: left;
}

.service-bar .icon {
  width: 50px;
  height: 50px;
}

.service-bar a {
  color: #00487b;
}

.social-bar {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row;
  flex-flow: row;
  -webkit-justify-content: left;
  justify-content: left;
  -webkit-align-items: left;
  align-items: center;
  padding: 45px 30px;
  background-color: transparent;
  max-width: 1350px;
  margin: 0 auto;
  color: white;
}

@media (min-width: 576px) {
  .social-bar {
    -webkit-flex-flow: row;
    flex-flow: row;
  }
}

.social-bar__text {
  margin-right: 20px;
}

.social-bar .icon {
  width: 40px;
  height: 40px;
  margin: 0 5px;
  stroke: white;
  fill: white;
}

.heading--4 {
  line-height: 1.1;
  font-size: 18px;
}

@media (min-width: 768px) {
  .heading--4 {
    font-size: 20px;
  }
}

@media (min-width: 992px) {
  .heading--4 {
    font-size: 24px;
  }
}

@media (min-width: 1200px) {
  .heading--4 {
    font-size: 26px;
  }
}



.newsletter.mdc-theme--dark .heading--1 {
  color: #eff0f1;
}

.newsletter.mdc-theme--dark .heading--3 {
  color: #0f90d0;
}


@media (min-width: 768px) {
  .corner__body {
    padding: 30px 30px 0 30px;
  }
}

@media (min-width: 992px) {
  .corner__body {
    padding: 50px 50px 0 50px;
  }
}

.corner--blue .corner__body {
  background-color: #00487b;
}

.heading--1 {
  line-height: 1.1;
  font-size: 34px;
}

@media (min-width: 768px) {
  .heading--1 {
    font-size: 44px;
  }
}

@media (min-width: 992px) {
  .heading--1 {
    font-size: 50px;
  }
}

@media (min-width: 1200px) {
  .heading--1 {
    font-size: 56px;
  }
}
.heading--3 {
  font-size: 20px;
  line-height: 1.1;
}

@media (min-width: 768px) {
  .heading--3 {
    font-size: 26px;
  }
}

@media (min-width: 992px) {
  .heading--3 {
    font-size: 30px;
  }
}

@media (min-width: 1200px) {
  .heading--3 {
    font-size: 34px;
  }
}

.corner::after {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  right: 0;
  bottom: 0;
  border-style: solid;
  border-width: 50px 50px 0 0;
  border-color: #fff transparent transparent transparent;
}
.corner--blue::after {
  border-top-color: #00487b;
}

.corner {
  position: relative;
  padding-bottom: 50px;
}

.corner::before {
  position: absolute;
  content: '';
  height: 50px;
  left: 0;
  right: 50px;
  bottom: 0;
  background-color: #fff;
}

.corner--blue::before {
  background-color: #00487b;
}

.mdc-theme--dark .button--outline {
  color: #fff!important;
  border-color: #fff!important;
  background-color: transparent !important;
}

footer .button {
  color: #fff!important;
  background-color: #00487b!important;
  border-color: #00487b!important;
  display: inline-block;
  border: 1px solid #00487b!important;
  border-radius: 4px;
  text-decoration: none!important;
  font-family: "NettoWebPro", -apple-system, system-ui, sans-serif, swap!important;
  font-size: 1rem!important;
  line-height: 2!important;
  padding: 3px 20px!important;
  cursor: pointer!important;
  transition: -webkit-transform .6s ease-out;
  transition: transform .6s ease-out!important;
  transition: transform .6s ease-out, -webkit-transform .6s ease-out!important;
}


</style>

